import React, { useState} from "react";
import { compliments } from "../../data/options.js";
import { Col, Row, Button, Container} from 'react-bootstrap';
import {useLocation} from "react-router-dom";
import Personale from "./clubmateUser/TableUser.js";
import Pacchetti from "./clubmatePackage/TablePackage.js";
import {Layer as LayerGrommet} from "grommet/components/Layer/index.js";
import {FormClose} from "grommet-icons";
import {Box, Grommet, Select, Text, Button as ButtonGrommet} from "grommet";
import AddPackage from "./clubmatePackage/AddPackage.js";
import AddUser from "./clubmateUser/AddUser.js";
import {theme} from "../../utilis/utils.js";
import Aree from "./clubmateArea/TableArea.js";
import AddArea from "./clubmateArea/AddArea.js";
import AddService from "./clubmateService/AddService.js";
import Servizi from "./clubmateService/TableService.js";


const Anagrafiche2 = (props) => {
    const options = compliments;
    const location = useLocation();
    const [registrySel,setRegistrySel] = useState(options[2]);
    const [elementSel,setElementSel]=React.useState(null);
    const [showAddLayer,setShowAddLayer] = React.useState(false);

    React.useEffect(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        setRegistrySel(urlParams.get('tab'))
    },[location])


    function onEscLayer(){
        setShowAddLayer(false);
        setElementSel(null);
    }

  return (
          <Container style={{backgroundColor:'#transparent', height:"100%"}}>
            <Row style={{marginTop:"10px"}}>
              <Col lg={12} style={{ display:"flex", justifyContent:"center" }} >
                <Text margin="small" style={{fontWeight:'bold', color:'#f8b20e'}}>SELEZIONA L'ANAGRAFICA: </Text>
                <Select style={{ width:"100%", fontWeight:'normal',textTransform:'uppercase' }}
                        options={options}
                        labelKey={"label"}
                        valueKey={"value"}
                        value={registrySel}
                        onChange={(e)=>{
                            const  value = e.option.value;
                            const urlParams = new URLSearchParams(window.location.search);
                            urlParams.set('tab', value);
                            const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams}`;
                            window.history.replaceState({}, value, newUrl);
                            setRegistrySel(value);
                        }}/>
                <Button style={{backgroundColor:"#f8b20e", marginLeft:"20px"}} onClick={()=>setShowAddLayer(true)}>INSERISCI</Button>{' '}
              </Col>
            </Row>
              {
                 registrySel === "pacchetti" && <Pacchetti setElementSel={setElementSel}/>
              }
              {
                 registrySel ==="utenti" && <Personale setElementSel={setElementSel}/>
              }
              {
                 registrySel ==="aree" && <Aree setElementSel={setElementSel}/>
              }
              {
                 registrySel ==="servizi" && <Servizi setElementSel={setElementSel}/>
              }
              {
                  (showAddLayer || elementSel) &&
                  <LayerGrommet style={{height:"100%", borderRadius:"20px", width:'fit-content'}} onEscLayer={onEscLayer} onClickOutside={onEscLayer}>
                    <Box height="100%" round="medium" pad="15px" background="#ffffff">
                       <ButtonGrommet  alignSelf="end" icon={<FormClose color="grey" size="35px" onClick={onEscLayer}/>}></ButtonGrommet>
                        {
                             registrySel==="pacchetti" && <AddPackage elementSel={elementSel} setElementSel={setElementSel}/>
                        }
                        {
                             registrySel==="utenti" && <AddUser elementSel={elementSel} setElementSel={setElementSel}/>
                        }
                        {
                             registrySel==="aree" && <AddArea elementSel={elementSel} setElementSel={setElementSel}/>
                        }
                        {
                             registrySel==="servizi" && <AddService elementSel={elementSel} setElementSel={setElementSel}/>
                        }
                    </Box>
                  </LayerGrommet>
              }
          </Container>
  )
}
export default Anagrafiche2;